import axios from "axios";
import logService from "@/services/log.service.js";

const VogtDataService = {
    /**
     * check if we have a valid configuration
     * @returns {boolean}
     */
    hasData() {
        return Boolean(this.getData());
    },

    /**
     * get the current configuration
     * @returns {string}
     */
    getData() {
        return JSON.parse(localStorage.getItem('vogt.app_data'));
    },

    /**
     * set the configursation
     * @param configuration
     */
    setData(configuration) {
        localStorage.setItem('vogt.app_data', JSON.stringify(configuration));
    },

    /**
     * get a specific configuration property
     **/
    get(key) {
        const config = this.getData();
        if (!config) return null;

        const keys = key.split('.');
        let result = config;

        for (const k of keys) {
            if (result[k] === undefined) return null;
            result = result[k];
        }

        return result;
    },

    /**
     * load the remote json configuration
     */
    async loadRemoteData() {
        let data = await axios.get('https://silokonfigurator.vogt-lagersysteme.de/src/php/data-processor.php');

        if(data.status !== 200) {
            throw new Error('Leider trat ein Fehler auf die config.json zu laden');
        }

        if (!JSON.stringify(data.data)) {
            throw new Error('Leider trat ein Fehler auf die config.json zu laden');
        }

        this.setData(data.data);
        logService.add('Added remote data');
        return data.data;
    }

}

export default VogtDataService;